const WorkDetails = () => {
	return (
		<>
			<div className="flex flex-col md:flex-row md:justify-evenly items-center justify-center py-4 border-t-2 border-b-2 border-black">
				{/* <h1 className="flex flex-col text-start text-3xl py-4">About Me</h1> */}
				{/* <div>
					<img
						className="flex object-cover h-60 border-2 justify-center"
						src={require("../../../assets/edu.jpg")}
						alt="image_not_available"
					/>
				</div> */}
				<div className="text-center md:text-start">
					<span className="font-bold text-lg">Work in Progress</span>
				</div>
			</div>
		</>
	);
};

export default WorkDetails;
